export const GET_ACTIVE_TYPES_STARTED = 'GET_ACTIVE_TYPES_STARTED'
export const GET_ACTIVE_TYPES_SUCCESS = 'GET_ACTIVE_TYPES_SUCCESS'
export const GET_ACTIVE_TYPES_FAILURE = 'GET_ACTIVE_TYPES_FAILURE'
